// Only default locale is statically imported.
// Non-default locales are loaded on demand via loadLocaleMessages().
import en from './locale/en';

const localeMessages = { en };

export default localeMessages;

/** Dynamically import a non-default locale's messages and cache them.
 *  Returns the loaded locale messages object. */
export async function loadLocaleMessages(locale) {
  if (localeMessages[locale]) {
    return localeMessages[locale];
  }

  let messages;
  switch (locale) {
    case 'th':
      messages = await import('./locale/th');
      break;
    case 'zh_CN':
      messages = await import('./locale/zh_CN');
      break;
    case 'zh_TW':
      messages = await import('./locale/zh_TW');
      break;
    default:
      // Fallback: try generic dynamic import (webpack will code-split each locale)
      try {
        messages = await import(/* webpackChunkName: "locale-[request]" */ `./locale/${locale}`);
      } catch {
        return null; // locale not available; use fallback
      }
  }
  const loaded = messages.default || messages;
  localeMessages[locale] = loaded;
  return loaded;
}
